export enum ARC_CREDENTIAL_STATUSES {
  verified = 'verified',
  rejected = 'rejected',
  pending = 'pending',
  error = 'error',
}
